import { AxiosError, AxiosRequestConfig } from 'axios';
import { apiGet, apiPost } from '../api';
import { IUploadCatalogResponse, QUOTE_TYPE } from 'types/bulkUpload';

const { REACT_APP_CATALOG } = process.env;

export const uploadQuotes = async (file: File, quoteTypeCode: QUOTE_TYPE): Promise<IUploadCatalogResponse> => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append(
    'body',
    JSON.stringify({
      quoteTypeCode
    })
  );

  return apiPost<AxiosRequestConfig, FormData>(`${REACT_APP_CATALOG}bulk-upload/quote`, formData)
    .then(response => Promise.resolve(response.data))
    .catch((error: AxiosError) => {
      const message = error.response?.data?.message;
      return Promise.reject(error.response?.status === 400 && message ? new SyntaxError(message) : error);
    });
};

export const downloadQuotesTemplate = async (): Promise<string> => {
  return apiGet<AxiosRequestConfig, { url: string }>(`${REACT_APP_CATALOG}bulk-upload/template-quote`)
    .then(response => Promise.resolve(response.url))
    .catch((error: AxiosError) => Promise.reject(error));
};

/**
 * Sube la planilla de cotización completada por Procurement asociándola a una cotización exploratoria existente.
 * Envía el archivo junto con la fecha de vencimiento. En error 400 con mensaje del backend, rechaza con SyntaxError.
 */
export const uploadProcurementQuote = async (
  quoteId: number,
  file: File,
  expirationDate: string
): Promise<IUploadCatalogResponse> => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('body', JSON.stringify({ expirationDate }));

  return apiPost<AxiosRequestConfig, FormData>(
    `${REACT_APP_CATALOG}bulk-upload/quote/${quoteId}/procurement-upload`,
    formData
  )
    .then(response => Promise.resolve(response.data))
    .catch((error: AxiosError) => {
      const message = error.response?.data?.message;
      return Promise.reject(error.response?.status === 400 && message ? new SyntaxError(message) : error);
    });
};
